import { getLastPage, goToLastPage } from 'Shared/utils';
import type { WindowApp } from '../types';

/**
 * Handles Shopify SSO redirect or goes to last page
 */
export const shopifySsoAndGoToLastPage = () => {
   const app = (window as any).App as WindowApp;
   if (!app?.shopifySsoRoute) {
      goToLastPage();
      return;
   }

   const ssoUrl = new URL(app.shopifySsoRoute);
   const lastPage = new URL(getLastPage(), window.location.origin);
   ssoUrl.searchParams.set('return_to', lastPage.toString());
   window.location.href = ssoUrl.href;
};
